export default __webpack_public_path__ + "static/24-a8d457fe369fcad911efc842a79e1882.png";